import { getAbTestV2, trackAbTestV2Variant } from 'dibs-buyer-layout/exports/clientABTestV2';

export const GUEST_CHECKOUT_V2_TEST_NAME = 'guestCheckoutV2';

export const GUEST_CHECKOUT_V2_CONTROL_NAME = 'control';
export const GUEST_CHECKOUT_V2_VARIANT_NAME = 'variant';

export function isGuestCheckoutV2Active(): boolean {
    // todo check ab test config
    return getAbTestV2(GUEST_CHECKOUT_V2_TEST_NAME)?.variant === GUEST_CHECKOUT_V2_VARIANT_NAME;
}

export const trackGuestCheckoutV2AbTestVariant = (): void => {
    trackAbTestV2Variant(GUEST_CHECKOUT_V2_TEST_NAME);
};
